module.exports = __webpack_public_path__ + "static/media/plus.5ede92a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/plus.svg
// module id = 1322
// module chunks = 0